import { formType } from "./form-type.const";

export interface SignInHeading {
  title: string;
  subtitle: string;
}

// The sign-in panel keeps one heading slot and swaps its copy with the form
// below it. The `confirmed` and `info` states are absent on purpose: both carry
// a heading the backend decided at runtime, and read it off `info` instead.
export const signInHeading: Record<string, SignInHeading> = {
  [formType.login]: {
    title: "Sign in to Quotiss",
    subtitle: "Enter your details to access the Quotiss platform.",
  },
  [formType.twoFactor]: {
    title: "Two-factor authentication",
    subtitle: "Enter the 6-digit code from your authenticator app.",
  },
  [formType.requestReset]: {
    title: "Reset your password",
    subtitle: "We will email you a link to choose a new one.",
  },
  [formType.reset]: {
    title: "Choose a new password",
    subtitle: "Pick a password you do not use anywhere else.",
  },
  [formType.join]: {
    title: "Join your organization",
    subtitle: "Set a password to finish setting up your account.",
  },
  [formType.activate]: {
    title: "Activate your account",
    subtitle: "Set a password and accept the terms to get started.",
  },
  [formType.register]: {
    title: "Create your account",
    subtitle:
      "Free account plus a 14-day trial of every premium feature. No credit card required.",
  },
  [formType.registered]: {
    title: "Check your email",
    subtitle: "Your registration form has been submitted.",
  },
};
